<template>
  <div class="page404">
    <h1 class="title" id="title">
      <span class="theme-color">天美支付</span>提醒您
    </h1>
    <div class="tips">
      请使用<span class="theme-color">支付宝APP、微信APP、云闪付APP</span> ”扫一扫“ 来完成付款！
    </div>
  </div>
</template>

<script>
export default {
  name:'',
  components: {},
  data() {
      return {

      };
  },
  methods: {
      back(){
          this.$router.back()
      }
  },
}
</script>
<style scoped lang="scss">
  .page404{
      height: 100%;
      display:flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .theme-color{
          color: var(--theme-color)!important;
      }
      .title{
        margin-top: 4rem;
        text-align: center;
        font-size: 36px;
      }
      .tips{
        color: #999999;
        font-size: 30px;
        /* width: 78%; */
        text-align: center;
        margin-top: 44px;
        line-height: 1.5;
      }
  }
</style>